import { useMemo } from 'react';
import { GROUPBY } from '../../../../constants/Reports';

export const useBaseData = (ptoData, groupby, columns) =>
  useMemo(() => {
    if (!ptoData) return [];

    const isGroupedByEmp = groupby.id === GROUPBY[0].value;

    return Object.entries(ptoData).map(([key, value]) => {
      const data = value.map((item) => {
        const [date, shiftOrName, reasonOrShift, quantityOrReason, quantity] =
          item;

        return isGroupedByEmp
          ? {
              date,
              shift: shiftOrName,
              reason: reasonOrShift,
              quantity: quantityOrReason,
            }
          : {
              date,
              name: shiftOrName,
              shift: reasonOrShift,
              reason: quantityOrReason,
              quantity,
            };
      });

      // Build reason summary (plain text) and total (for quantity column)
      const reasonToQuantityMap = data.reduce((acc, row) => {
        const reasonKey = row.reason;
        const qtyVal = Number(row.quantity);
        if (!reasonKey || Number.isNaN(qtyVal)) return acc;
        acc[reasonKey] = (acc[reasonKey] || 0) + qtyVal;
        return acc;
      }, {});

      const summary = Object.entries(reasonToQuantityMap)
        .map(([reasonKey, totalQty]) => `${reasonKey}: ${+Number(totalQty).toFixed(2)}`)
        .join(', ');

      const total = data.reduce((acc, row) => {
        const val = Number(row.quantity);
        return !Number.isNaN(val) ? acc + val : acc;
      }, 0);

      const footer = Array.isArray(columns)
        ? columns.map((col, index) => {
            if (index === 0) return summary;
            if (col.field === 'quantity') return +total.toFixed(2);
            return '';
          })
        : undefined;

      return { name: key, data, footer };
    });
  }, [ptoData, groupby.id, columns]);
